import React, {FC, memo, useMemo, useEffect} from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import TextField from '@pixel/core/TextField'
import {styled} from "@pixel/core/styles";
import {useMultipleLocalizedText} from "../../contexts/Localization/localizationHooks";
import useAutomationFormDataQuery, {DEFAULT_AUTOMATION_FORM_DATA} from "../hooks/useAutomationFormDataQuery";
import MenuItem from "@pixel/core/MenuItem";
import Stack from "@pixel/core/Stack";
import ActionField from "./ActionField";
import {renderLocalizedMenuItems} from "../../components/LocalizedMenuItem";
interface ActionTypeProps {
    actionTypeIndex: number,
    children: any
}

const ActionTypeSection = styled('div')(({ theme }) => ({
}))

const ActionType: FC<ActionTypeProps> = ({
    actionTypeIndex,
    children,
}) => {

    const {
        AUTOMATION_INPUT_NO_OPTIONS,
    } = useMultipleLocalizedText()

    const { control, setValue } = useFormContext()

    const {
        data,
    } = useAutomationFormDataQuery({
        onSuccess: () => {},
    })

    const { ACTIONS } = data || DEFAULT_AUTOMATION_FORM_DATA

    const localizedActionTypes = useMemo(() =>
            ACTIONS.map(action => ({
                text: action.localeKey,
                value: action.actionType,
            })),
        [ACTIONS])

    const {
        AUTOMATION_FORM_ACTION,
        COMMON_AND,
    } = useMultipleLocalizedText()

    useEffect(() => {
        setValue(`companyActions.${actionTypeIndex}.sortOrder`, actionTypeIndex)
    }, [actionTypeIndex, setValue])


    return (
        <Stack direction="column" sx={{ width: '100%' }}>
            <ActionTypeSection>
                <Controller
                    control={control}
                    rules={{ required: true }}
                    name={`companyActions.${actionTypeIndex}.actionType`}
                    render={({ field, fieldState, }) => (
                        <TextField
                            id={`automation-form-action-type-field-${actionTypeIndex}`}
                            required
                            select
                            label={actionTypeIndex === 0 ? AUTOMATION_FORM_ACTION : COMMON_AND}
                            value={field.value}
                            onBlur={field.onBlur}
                            onChange={field.onChange}
                            error={fieldState.invalid}
                            errorText={fieldState?.error?.message || ''}
                            augmentField={() => (
                                <>{children}</>
                            )}
                            fullWidth
                        >
                            {
                                localizedActionTypes.length === 0 ?
                                    (
                                        <MenuItem value="none" disabled>{AUTOMATION_INPUT_NO_OPTIONS}</MenuItem>
                                    ) :
                                    (
                                        localizedActionTypes.map(renderLocalizedMenuItems)
                                    )
                            }
                        </TextField>
                    )}
                />
                <ActionField actionFieldIndex={actionTypeIndex} actions={ACTIONS}></ActionField>
                <Controller
                    control={control}
                    name={`companyActions.${actionTypeIndex}.sortOrder`}
                    defaultValue={actionTypeIndex}
                    render={({ field, }) => (
                        <TextField
                            value={actionTypeIndex}
                            hidden={true}
                        >
                        </TextField>
                    )}
                />
            </ActionTypeSection>
        </Stack>
    )

}

export default memo(ActionType)
